<div class="outer-container">
    <app-current-path></app-current-path>
    <div class="console-container">
        <div class="title-wrapper">
            <span class="action-name"> {{ action }} </span><span class="records"> ({{ totalRecords }} records
                found)</span>
        </div>
        <div class="input-wrapper">
            <app-console-search [findOptions]="findOptions" [showDateRange]="showDateRange" [headercount]="headercount"
                [showHideHeaderColumnCount]="true" (clearSearchBoxEvent)="clearSearchBox()"
                (clearFilterEvent)="clearFilter()" (applyFilterByFieldEvent)="applyFilterByField($event)"
                (showHideColumnsEvent)="showHideColumns()"
                [initialFromDate]="fromDate" 
                [initialToDate]="toDate"
                [isAIInteractions]="true"
                (resetDateRangeEvent)="resetDateRange($event)"
                (applySelectedDateRangeEvent)="applySelectedDateRange($event)"></app-console-search>

            <!-- <app-console-search [findOptions]="findOptions" [showDateRange]="showDateRange" [headercount]="headercount"
                [showHideHeaderColumnCount]="true" (clearSearchBoxEvent)="clearSearchBox()"
                (applyFilterByFieldEvent)="applyFilterByField($event)" (showHideColumnsEvent)="showHideColumns()">
            </app-console-search> -->
        </div>
        <div class="table-wrapper">
            <!-- [scrollable]="true"
      [scrollHeight]="innerHeight + 'vh'" -->
            <p-table [columns]="cols" scrollDirection="horizontal" [value]="interactionList" [lazy]="true"
                (onLazyLoad)="loadInteractions($event)" dataKey="id" [tableStyle]="{ 'min-width': '50rem' }"
                [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [loading]="loading" selectionMode="single"
                (onRowSelect)="onRowSelect_AI($event)" [scrollable]="true" [style]="{ width: '100%' }"
                [(first)]="first">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of cols">
                            <th *ngIf="!col?.hide" [ngStyle]="{ 'min-width': col.minWidth + 'rem' }">
                                {{ col.label }}
                                <span class="fts">
                                    <span class="filter" *ngIf="col.showFilter"
                                        (click)="toggleCustomColumnFilter(col.name)">
                                        <ng-container *ngIf="col.filterVals; else notSelected">
                                            <img alt="" class="filter-btn"
                                                src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                                        </ng-container>
                                        <ng-template #notSelected>
                                            <img alt="" class="filter-btn"
                                                src="{{ baseHref }}/assets/images/icon-filter.png" />
                                        </ng-template>
                                    </span>
                                    <span class="sort" (click)="sortByColumn(col.name)">
                                        <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                                            <ng-container *ngIf="col.isAsc; else falseBlock">
                                                <img alt="" class="sort-btn"
                                                    src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                                            </ng-container>
                                            <ng-template #falseBlock>
                                                <img alt="" class="sort-btn"
                                                    src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #others>
                                            <img alt="" class="sort-btn"
                                                src="{{ baseHref }}/assets/images/icon-sort.png" />
                                        </ng-template>
                                    </span>
                                </span>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        <ng-container *ngFor="let col of cols">
                            <td *ngIf="
                  !col?.hide &&
                  col.name != 'Recording' &&
                  col.name == 'Audits' &&
                  col.name != 'HandlingTime' &&
                  col.name != 'Date'
                ">
                                <!-- <div
                  *ngIf="rowData['ScorecardOwner'] == false && rowData['Scorecards'] != 0"
                  class="iconButton iconScorecard hideLabel"
                  title="Scorecards ({{ rowData['Scorecards'] }})"
                ></div>
              <div
                  *ngIf="rowData['ScorecardOwner'] == true && rowData['Scorecards'] != 0"
                  class="iconButton iconScorecardPositive hideLabel"
                  title="Scorecards ({{ rowData['Scorecards'] }})"
                ></div>
                <div
                  *ngIf="rowData['ScorecardOwner'] == false && rowData['Scorecards'] == 0"
                  class="iconButton hideLabel"
                  title="Scorecards ({{ rowData['Scorecards'] }})"
                ></div> -->
                                <span *ngIf="rowData['ScorecardOwner'] == false && rowData['Scorecards'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-scorecard.png"
                                        class="iconButton auditIconsCommonCSS iconScorecard"
                                        title="Scorecards ({{ rowData['Scorecards'] }})" />
                                </span>
                                <span *ngIf="rowData['ScorecardOwner'] == true && rowData['Scorecards'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-scorecard-positive.png"
                                        class="iconButton auditIconsCommonCSS iconScorecardPositive"
                                        title="Scorecards ({{ rowData['Scorecards'] }})" />
                                </span>
                                <!-- <div
                  *ngIf="rowData['CalibrationOwner'] == false && rowData['Calibrations'] != 0"
                  class="iconButton iconCalibrating hideLabel"
                  title="Calibrations ({{ rowData['Calibrations'] }})"
                ></div>
                <div
                  *ngIf="rowData['CalibrationOwner'] == true && rowData['Calibrations'] != 0"
                  class="iconButton iconCalibrating hideLabel"
                  title="Calibrations ({{ rowData['Calibrations'] }})"
                ></div>
                <div
                  *ngIf="rowData['CalibrationOwner'] == false && rowData['Calibrations'] == 0"
                  class="iconButton hideLabel"
                  title="Calibrations ({{ rowData['Calibrations'] }})"
                ></div> -->
                                <span *ngIf="rowData['CalibrationOwner'] == false && rowData['Calibrations'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-calibrating.png"
                                        class="iconButton auditIconsCommonCSS iconCalibrating"
                                        title="Calibrations ({{ rowData['Calibrations'] }})" />
                                </span>
                                <span *ngIf="rowData['CalibrationOwner'] == true && rowData['Calibrations'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-calibrating-positive.png"
                                        class="iconButton auditIconsCommonCSS iconCalibratingPositive"
                                        title="Calibrations ({{ rowData['Calibrations'] }})" />
                                </span>
                                <!-- <div
                  *ngIf="rowData['EvaluationOwner'] == false && rowData['Evaluations'] != 0"
                  class="iconButton iconEvaluation hideLabel"
                  title="Evaluations ({{ rowData['Evaluations'] }})"
                ></div>
                <div
                  *ngIf="rowData['EvaluationOwner'] == true && rowData['Evaluations'] != 0"
                  class="iconButton iconEvaluation hideLabel"
                  title="Evaluations ({{ rowData['Evaluations'] }})"
                ></div>
                <div
                  *ngIf="rowData['EvaluationOwner'] == false && rowData['Evaluations'] == 0"
                  class="iconButton hideLabel"
                  title="Evaluations ({{ rowData['Evaluations'] }})"
                ></div> -->
                                <span *ngIf="rowData['EvaluationOwner'] == false && rowData['Evaluations'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-evaluation.png"
                                        class="iconButton auditIconsCommonCSS iconEvaluation"
                                        title="Evaluations ({{ rowData['Evaluations'] }})" />
                                </span>
                                <span *ngIf="rowData['EvaluationOwner'] == true && rowData['Evaluations'] != 0">
                                    <img alt="" src="{{ baseHref }}/assets/images/icon-evaluation-positive.png"
                                        class="iconButton auditIconsCommonCSS iconEvaluationPositive"
                                        title="Evaluations ({{ rowData['Evaluations'] }})" />
                                </span>
                            </td>

                            <td *ngIf="
                  !col?.hide &&
                  col.name == 'Recording' &&
                  col.name != 'Audits' &&
                  col.name != 'HandlingTime' &&
                  col.name != 'Date'
                ">
                                <div class="icon-container">
                                    <div *ngIf="rowData[col.name] != null && rowData[col.name] != ''"
                                        class="iconButton iconAudio hideLabel" title="Audio"><img class="icon"
                                            src="{{ baseHref }}/assets/images/icon-audio.png" alt="Audio" /></div>
                                    <div *ngIf="rowData['VideoRecording'] != null && rowData['VideoRecording'] != ''"
                                        class="iconButton iconVideo hideLabel" title="Video"><img class="icon"
                                            src="{{ baseHref }}/assets/images/icon-video.svg" alt="Video" />
                                    </div>
                                </div>
                            </td>
                            <td *ngIf="
                  !col?.hide &&
                  col.name == 'HandlingTime' &&
                  col.name != 'Recording' &&
                  col.name != 'Audits' &&
                  col.name != 'Date' &&
                  rowData[col.name] != 0
                ">
                                {{ col.type == 'numeric' ? formatTime(rowData[col.name]) : rowData[col.name] }}
                            </td>
                            <td *ngIf="
                  !col?.hide &&
                  col.name == 'HandlingTime' &&
                  col.name != 'Recording' &&
                  col.name != 'Audits' &&
                  col.name != 'Date' &&
                  rowData[col.name] == 0
                ">
                                {{ col.type == 'numeric' ? rowData[col.name] : rowData[col.name] }}
                            </td>
                            <td
                                *ngIf="!col?.hide && col.name != 'Recording' && col.name != 'Audits' && col.name != 'HandlingTime' && col.type == 'date'">
                                {{ (rowData[col.name] | custdate) }}
                            </td>
                            <td *ngIf="!col?.hide && col.name == 'AIReview'">
                                <span *ngIf="rowData[col.name]; else aiReviewEmpty"
                                      class="ai-review-badge"
                                      [class.ai-completed]="rowData[col.name]?.toLowerCase().includes('completed')"
                                      [class.ai-failed]="rowData[col.name]?.toLowerCase().includes('failed')"
                                      [class.ai-in-progress]="rowData[col.name]?.toLowerCase().includes('in progress') || rowData[col.name]?.toLowerCase().includes('inprogress')">
                                    {{ rowData[col.name] }}
                                </span>
                                <ng-template #aiReviewEmpty>-</ng-template>
                            </td>
                            <td *ngIf="!col?.hide && col.name != 'Recording' && col.name != 'Audits' && col.name != 'HandlingTime' && col.name != 'AIReview' && col.type != 'date'"
                                [innerHTML]="col.name == 'CaseID' && rowData[col.name] == 0 ? '' : getModelText(rowData[col.name])"></td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length">No Data Available</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>